<div class="forgot-password-container">
  <div class="forgot-password-content">
    <div class="brand-header">
      <img src="assets/images/logo.png" class="brand-logo" alt="Ryno logo" />
    </div>

    <div class="forgot-password-card">
      <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()" class="forgot-password-form">
            <h2 class="welcome-text">Forgot password?</h2>
            <p class="sub-text">
                Enter your email or mobile number for verification
            </p>

            <div class="contact-type-switch">
                <button type="button" class="type-button" [class.active]="contactType === 'email'"
                    (click)="setContactType('email')">
                    Email
                </button>
                <button type="button" class="type-button" [class.active]="contactType === 'mobile_number'"
                    (click)="setContactType('mobile_number')">
                    Mobile Number
                </button>
            </div>

            <div class="form-group" *ngIf="contactType === 'email'">
                <label for="email">Email</label>
                <input type="email" id="email" formControlName="email" class="form-control" placeholder="Enter your email" />
            </div>

            <div class="form-group" *ngIf="contactType === 'mobile_number'">
                <label for="mobileNumber">Mobile Number</label>
                <div class="phone-input-group">
                    <select class="country-select" [(ngModel)]="selectedCountryCode" [ngModelOptions]="{standalone: true}">
                        <option *ngFor="let country of countries" [value]="country.dialCode">
                            {{ country.flag }} {{ country.dialCode }}
                        </option>
                    </select>
                    <input type="tel" id="mobileNumber" formControlName="mobileNumber" class="form-control phone-input"
                        placeholder="Enter mobile number" />
                </div>
            </div>

            <button type="submit" class="confirm-button" [disabled]="!forgotPasswordForm.valid" [title]="
          !forgotPasswordForm.valid
            ? (contactType === 'email'
              ? 'Please enter a valid email'
              : 'Please enter a valid mobile number')
            : 'Confirm'
        ">
        Continue <span aria-hidden="true">&#8594;</span>
      </button>

            <div class="go-to-login">
                Go to
                <a routerLink="/login" class="go-to-login-link">
          Log In
        </a>
            </div>
      </form>
    </div>
  </div>
</div>